import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { DefaultManufacturersAdapter } from './adapters/default-manufacturers.adapter';
import { OccDefaultManufacturersAdapter } from './adapters/impl/occ-default-manufacturers.adapter';

@NgModule({ imports: [CommonModule], providers: [
        {
            provide: DefaultManufacturersAdapter,
            useClass: OccDefaultManufacturersAdapter,
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class OccModule { }
